import conversations from './conversations';
import settings from './settings';
import assistants from './assistants';
import agents from './agents';
import user from './user';
import tools from './tools';

export default [
    ...conversations,
    ...settings,
    ...assistants,
    ...agents,
    ...tools,
    ...user
].map(layout => {
    if(layout.routes) {
        layout.routes = layout.routes.map(route => {
            if(route.routes) {
                route.routes = route.routes?.map((subroute) => {
                    if(subroute.analytics?.name && route.analytics?.name) {
                        subroute.analytics.name = [...route.analytics?.name || [], ...subroute.analytics?.name || []].filter(Boolean);
                    }
                    return subroute;
                });
            }
            return route;
        })
    }
    return layout;
});